import React from 'react';
import { FaInstagram, FaGoogle, FaWhatsapp, FaTiktok, FaBriefcase } from 'react-icons/fa';
import SocialMediaPin from '../socialMedia/SocialMediaPin';
import {
  GOOGLE_URL,
  INSTAGRAM_URL,
  TIKTOK_URL,
  UPWORK_URL,
} from '../../utils/Constants';

function FooterSocialCTA() {
  const socialMediaLinks = [
    {
      serviceName: 'Instagram',
      icon: <FaInstagram size={24} />,
      url: INSTAGRAM_URL,
      ariaLabel: 'Open Instagram profile in a new tab',
      title: 'Instagram',
    },
    {
      serviceName: 'Google',
      icon: <FaGoogle size={24} />,
      url: GOOGLE_URL,
      ariaLabel: 'Open Google profile in a new tab',
      title: 'Google',
    },
    // {
    //   serviceName: 'WhatsApp',
    //   icon: <FaWhatsapp size={24} />,
    //   url: `https://wa.me/${CompanyWhatsappNumber.replace(/\D/g, '')}`,
    //   ariaLabel: 'Open WhatsApp chat in a new tab',
    //   title: 'WhatsApp',
    // },
    {
      serviceName: 'TikTok',
      icon: <FaTiktok size={24} />,
      url: TIKTOK_URL,
      ariaLabel: 'Open TikTok profile in a new tab',
      title: 'TikTok',
    },
    {
      serviceName: 'Upwork',
      icon: <FaBriefcase size={24} />,
      url: UPWORK_URL,
      ariaLabel: 'Open Upwork profile in a new tab',
      title: 'Upwork',
    },
  ];

  return (
    <section className="grid justify-center">
      <div className="grid grid-flow-col w-fit gap-1">
        {socialMediaLinks.map((social) => (
          <SocialMediaPin
            key={social.serviceName}
            serviceName={social.serviceName}
            icon={social.icon}
            url={social.url}
            ariaLabel={social.ariaLabel}
            title={social.title}
          />
        ))}
      </div>
    </section>
  );
}

export default FooterSocialCTA;
